export enum LoaderState {
    LOADING,
    FADE_IN
}
